<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',

  data() {
    return {
      locale: zhCN
    }
  },
  watch: {
    $route() {
      // 取得浏览器的userAgent字符串
      var userAgent = navigator.userAgent
      // 判断是否为小于IE11的浏览器
      var isLessIE11 =
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      if (isLessIE11) {
        this.$router.push('/upgrade')
        console.log('IE版本太低')
      }
    }
  },
  created() {
    //在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(localStorage.getItem('store'))
        )
      )
    }
    // //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  mounted() {}
}
</script>

<style>
@import './assets/css/font';
.ant-layout-content {
  height: auto !important;
  min-height: auto !important;
}
/* 全局弹出提示默认样式放大调整 */
.ant-message .anticon {
  font-size: 22px !important;
}
.ant-message {
  font-size: 22px !important;
  /* font-weight: 700; */
}
body {
  -webkit-print-color-adjust: exact;
}

/* 公共 审批状态样式 */
.card-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
</style>




// WEBPACK FOOTER //
// src/App.vue